(()=>{'use strict';
const root=window.Shopify?.routes?.root||'/';
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const form=()=>document.getElementById('productForm');
function getChoices(){const f=form();if(!f)return [];return $$('.snob-option-values',f).map(g=>({index:Number(g.dataset.optionIndex),value:$('.snob-option.active',g)?.dataset.value||''}));}
function currentVariant(){const f=form(),sel=f&&document.getElementById('variantSelect');if(!sel)return null;const choices=getChoices();if(choices.some(x=>!x.value))return null;const opt=[...sel.options].find(o=>{if(o.disabled)return false;try{const vals=JSON.parse(o.dataset.options||'[]').map(String);return choices.every(x=>vals[x.index]===String(x.value));}catch(e){return false}});if(opt){sel.value=opt.value;sel.dispatchEvent(new Event('change',{bubbles:true}));return opt}return null;}
function sizeSelected(){const f=form();if(!f)return null;const block=$$('.snob-option-block',f).find(b=>/SIZE/.test((b.querySelector('.snob-option-head')?.textContent||'').toUpperCase()));return block?.querySelector('.snob-option.active')||null;}
function choose(btn){const group=btn.closest('.snob-option-values');if(!group)return;$$('.snob-option',group).forEach(x=>{x.classList.remove('active');x.setAttribute('aria-pressed','false')});btn.classList.add('active');btn.setAttribute('aria-pressed','true');const block=btn.closest('.snob-option-block');const label=block?.querySelector('.snob-size-selected');if(label&&/SIZE/.test((block.querySelector('.snob-option-head')?.textContent||'').toUpperCase()))label.textContent='SIZE '+String(btn.dataset.value).toUpperCase()+' SELECTED ✓';currentVariant();}
async function addToBag(btn,checkout){
 const f=form();if(!f){console.error('SNOB product form missing');return}
 const sizeBlock=$$('.snob-option-block',f).find(b=>/SIZE/.test((b.querySelector('.snob-option-head')?.textContent||'').toUpperCase()));
 const size=sizeSelected();
 if(sizeBlock&&!size){const l=sizeBlock.querySelector('.snob-size-selected');if(l)l.textContent='PLEASE SELECT A SIZE';sizeBlock.scrollIntoView({behavior:'smooth',block:'center'});return}
 let opt=currentVariant();
 const sel=document.getElementById('variantSelect');
 if(!opt?.value&&sel?.value){const candidate=[...sel.options].find(o=>o.value===sel.value&&!o.disabled);if(candidate)opt=candidate}
 if(!opt?.value){const l=sizeBlock?.querySelector('.snob-size-selected');if(l)l.textContent='THIS SIZE IS UNAVAILABLE';return}
 const qty=Math.max(1,Number($('[name="quantity"]',f)?.value||1));
 const original=btn.innerHTML;btn.disabled=true;btn.setAttribute('aria-busy','true');btn.innerHTML='<span>ADDING…</span>';
 try{
  const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:Number(opt.value),quantity:qty}]})});
  const data=await res.json().catch(()=>({}));
  if(!res.ok)throw new Error(data.description||data.message||'Unable to add this item to cart');
  btn.disabled=false;btn.removeAttribute('aria-busy');btn.innerHTML=original;
  if(checkout){window.location.assign(root+'checkout');return}
  if(typeof window.openCartDrawer==='function')window.openCartDrawer();
  else {const d=document.getElementById('snobCartDrawer'),o=document.getElementById('snobCartOverlay');if(!d)throw new Error('Cart drawer is missing');if(o)o.hidden=false;d.classList.add('show');o?.classList.add('show');d.setAttribute('aria-hidden','false');document.body.classList.add('snob-cart-open')}
  document.dispatchEvent(new CustomEvent('snob:cart-updated'));
 }catch(e){console.error('SNOB Add to Cart:',e);btn.disabled=false;btn.removeAttribute('aria-busy');btn.innerHTML=original;let note=f.querySelector('.snob-add-error');if(!note){note=document.createElement('p');note.className='snob-add-error';note.setAttribute('role','alert');btn.insertAdjacentElement('afterend',note)}note.textContent=e.message||'Could not add to cart. Please try again.'}
}
function bindProductActions(){
 const f=form();if(!f||f.dataset.snobActionsBound)return;
 f.dataset.snobActionsBound='1';
 $$('.snob-add',f).forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();addToBag(btn,false)}));
 $$('.snob-buy',f).forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();addToBag(btn,true)}));
 $$('.snob-option',f).forEach(btn=>{btn.setAttribute('aria-pressed',btn.classList.contains('active')?'true':'false');btn.addEventListener('click',e=>{e.preventDefault();choose(btn)})});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindProductActions,{once:true});else bindProductActions();
document.addEventListener('DOMContentLoaded',()=>{const f=form();if(f){$$('.snob-option',f).forEach(b=>b.setAttribute('aria-pressed','false'));}});
})();

/* SNOB PRODUCT GALLERY */
(()=>{const showImage=t=>{const main=document.getElementById('snobMainImage');if(!main||!t)return;const src=t.dataset.image;if(!src)return;document.querySelectorAll('.snob-thumb').forEach(x=>x.classList.remove('active'));t.classList.add('active');const next=new Image();next.onload=()=>{main.src=src;main.srcset=src;main.removeAttribute('sizes');main.classList.remove('fading')};main.classList.add('fading');next.src=src};document.addEventListener('click',e=>{const t=e.target.closest('.snob-thumb');if(t){e.preventDefault();e.stopPropagation();showImage(t)}});document.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){const t=document.activeElement?.closest('.snob-thumb');if(t){e.preventDefault();showImage(t)}}})})();

/* SNOB MENU */
(()=>{function init(){const b=document.getElementById('menuBtn'),m=document.getElementById('mobileMenu');if(!b||!m||b.dataset.snobMenuInit)return;b.dataset.snobMenuInit='1';const close=()=>{m.classList.remove('show');b.setAttribute('aria-expanded','false');b.setAttribute('aria-label','Open menu')};b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();const open=m.classList.toggle('show');b.setAttribute('aria-expanded',open?'true':'false');b.setAttribute('aria-label',open?'Close menu':'Open menu')});m.addEventListener('click',e=>{if(e.target.closest('a'))close()});document.addEventListener('click',e=>{if(m.classList.contains('show')&&!m.contains(e.target)&&e.target!==b&&!b.contains(e.target))close()});document.addEventListener('keydown',e=>{if(e.key==='Escape')close()})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init()})();
/* SNOB CART DRAWER — markup: layout/theme.liquid · styles: assets/snob-cart-drawer.css */
(()=>{
  'use strict';
  const root=window.Shopify?.routes?.root||'/';
  const $=s=>document.querySelector(s);

  /* ---- money -----------------------------------------------------------
     Matches the reference: line price shows paise (₹2,449.00), the struck-through
     price is grouped without paise (₹4,749), total and savings are plain (₹2449).
     Change a format here and it changes everywhere in the drawer. */
  const inr=(cents,digits)=>'₹'+(cents/100).toLocaleString('en-IN',{minimumFractionDigits:digits,maximumFractionDigits:digits});
  const fmtLine=c=>inr(c,2);
  const fmtCompare=c=>inr(c,0);
  const fmtPlain=c=>'₹'+Math.round(c/100);
  const esc=t=>String(t==null?'':t).replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  const sized=(url,w)=>url?url+(url.includes('?')?'&':'?')+'width='+w:'';

  const ICON_TAG='<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3.4 13.4a2 2 0 0 1 0-2.8l7.2-7.2A2 2 0 0 1 12 2.8H19a2 2 0 0 1 2 2v7a2 2 0 0 1-.4 1.6ZM16.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/></svg>';
  const ICON_MINUS='<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  const ICON_PLUS='<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>';

  /* ---- offer countdown (per browsing session) --------------------------- */
  (function initOfferTimer(){
    const h=$('#snobTimerHours'),m=$('#snobTimerMinutes'),s=$('#snobTimerSeconds');
    if(!h||!m||!s||window.__snobOfferTimerStarted)return;
    window.__snobOfferTimerStarted=true;
    const key='snobOfferDeadline_230_v3';
    let deadline=0;
    try{deadline=Number(sessionStorage.getItem(key)||0)}catch(e){}
    if(!deadline||deadline<=Date.now()){deadline=Date.now()+(2*3600+30*60)*1000;try{sessionStorage.setItem(key,String(deadline))}catch(e){}}
    const pad=n=>String(n).padStart(2,'0');
    const tick=()=>{const left=Math.max(0,Math.floor((deadline-Date.now())/1000));h.textContent=pad(Math.floor(left/3600))+'Hrs';m.textContent=pad(Math.floor(left%3600/60))+'Min';s.textContent=pad(left%60)+'Sec'};
    tick();window.setInterval(tick,1000);
  })();

  /* ---- compare-at prices (cart.js does not include them) ---------------- */
  const comparePrices={},compareLoading={};
  let cartSnapshot=null,refreshToken=0,pendingRefresh=null,updateQueue=Promise.resolve(),updateVersion=0,lastFocus=null;

  function fetchComparePrices(cart){
    (cart.items||[]).forEach(item=>{
      if(!item.handle||comparePrices[item.handle]||compareLoading[item.handle])return;
      compareLoading[item.handle]=true;
      fetch(root+'products/'+item.handle+'.js',{credentials:'same-origin'})
        .then(r=>r.ok?r.json():null)
        .then(product=>{
          const byVariant={};
          (product&&product.variants||[]).forEach(v=>{byVariant[String(v.id)]=Number(v.compare_at_price)||0});
          comparePrices[item.handle]=byVariant;
          if(cartSnapshot)render(cartSnapshot);
        })
        .catch(()=>{comparePrices[item.handle]={}})
        .finally(()=>{delete compareLoading[item.handle]});
    });
  }
  const compareFor=i=>Number(comparePrices[i.handle]&&comparePrices[i.handle][String(i.variant_id)])||0;
  /* the "was" price for a whole line: the higher of compare-at and pre-discount price */
  const wasLine=i=>Math.max(compareFor(i)*i.quantity,Number(i.original_line_price)||0);

  /* ---- render ----------------------------------------------------------- */
  function itemHTML(i){
    const was=wasLine(i),onSale=was>i.final_line_price;
    const pct=onSale?Math.round((was-i.final_line_price)/was*100):0;
    const variant=i.variant_title&&i.variant_title!=='Default Title'?i.variant_title:'';
    const src=sized(i.image||(i.featured_image&&i.featured_image.url)||'',200);
    return '<article class="sd-item">'
      +'<div class="sd-media"><img src="'+esc(src)+'" alt="'+esc(i.product_title)+'" width="70" height="81" loading="lazy">'
      +(pct>0?'<span class="sd-badge" aria-label="'+pct+'% off"><span>'+pct+'%</span><span>OFF</span></span>':'')+'</div>'
      +'<div class="sd-info">'
        +'<div class="sd-main"><p class="sd-name">'+esc(i.product_title)+'</p>'+(variant?'<p class="sd-variant">'+esc(variant)+'</p>':'')+'</div>'
        +'<div class="sd-prices"><span class="sd-price">'+fmtLine(i.final_line_price)+'</span>'+(onSale?'<s class="sd-compare">'+fmtCompare(was)+'</s>':'')+'</div>'
        +'<div class="sd-qty">'
          +'<button type="button" data-key="'+esc(i.key)+'" data-qty="'+(i.quantity-1)+'" aria-label="'+(i.quantity>1?'Decrease quantity':'Remove item')+'">'+ICON_MINUS+'</button>'
          +'<output aria-label="Quantity">'+i.quantity+'</output>'
          +'<button type="button" data-key="'+esc(i.key)+'" data-qty="'+(i.quantity+1)+'" aria-label="Increase quantity">'+ICON_PLUS+'</button>'
        +'</div>'
      +'</div></article>';
  }

  function render(cart){
    cartSnapshot=cart;
    fetchComparePrices(cart);
    const drawer=$('#snobCartDrawer'),count=$('#snobCartCount'),dc=$('#snobDrawerCount'),items=$('#snobCartItems'),sub=$('#snobCartSubtotal'),savings=$('#snobBagSavings'),note=$('#snobGiftNote');
    if(drawer)drawer.classList.toggle('is-empty',!cart.item_count);
    if(count)count.textContent=cart.item_count;
    if(dc)dc.textContent='('+cart.item_count+')';
    if(sub)sub.textContent=fmtPlain(cart.total_price);
    if(items)items.innerHTML=cart.item_count
      ?cart.items.map(itemHTML).join('')
      :'<div class="sd-empty"><p>Your bag is empty</p><a href="'+root+'collections/all">Continue shopping</a></div>';
    if(savings){
      const saved=cart.items.reduce((n,i)=>n+Math.max(0,wasLine(i)-i.final_line_price),0);
      savings.innerHTML=saved>0?ICON_TAG+'<span>You are saving <strong>'+fmtPlain(saved)+'</strong></span>':'';
    }
    if(note&&typeof cart.note==='string'&&note.dataset.edited!=='1')note.value=cart.note;
  }

  async function refresh(){
    if(pendingRefresh)return pendingRefresh;
    const token=++refreshToken;
    const request=fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(r=>{if(!r.ok)throw new Error('Cart refresh failed');return r.json()})
      .then(cart=>{if(token===refreshToken)render(cart);return cart});
    pendingRefresh=request;
    request.finally(()=>{if(pendingRefresh===request)pendingRefresh=null});
    return request;
  }

  /* ---- open / close ----------------------------------------------------- */
  function open(){
    const o=$('#snobCartOverlay'),d=$('#snobCartDrawer');if(!d)return;
    lastFocus=document.activeElement;
    if(o)o.hidden=false;
    d.classList.add('show');o&&o.classList.add('show');
    d.setAttribute('aria-hidden','false');document.body.classList.add('snob-cart-open');
    const closeBtn=$('#snobCartClose');if(closeBtn)window.requestAnimationFrame(()=>closeBtn.focus({preventScroll:true}));
    refresh().catch(err=>console.warn('SNOB cart refresh:',err));
  }
  function close(){
    const o=$('#snobCartOverlay'),d=$('#snobCartDrawer');if(!d||!d.classList.contains('show'))return;
    d.classList.remove('show');o&&o.classList.remove('show');
    window.setTimeout(()=>{if(o&&!o.classList.contains('show'))o.hidden=true},250);
    d.setAttribute('aria-hidden','true');document.body.classList.remove('snob-cart-open');
    if(lastFocus&&typeof lastFocus.focus==='function'&&document.contains(lastFocus))lastFocus.focus({preventScroll:true});
    lastFocus=null;
  }
  window.openCartDrawer=open;
  window.closeCartDrawer=close;

  /* ---- quantity (optimistic, queued) ------------------------------------ */
  function changeQuantity(key,quantity){
    if(!cartSnapshot)return;
    const item=cartSnapshot.items.find(i=>i.key===key);if(!item)return;
    const version=++updateVersion;refreshToken++;
    item.quantity=quantity;
    item.final_line_price=item.final_price*quantity;
    item.original_line_price=(item.original_price||item.final_price)*quantity;
    cartSnapshot.items=cartSnapshot.items.filter(i=>i.quantity>0);
    cartSnapshot.item_count=cartSnapshot.items.reduce((n,i)=>n+i.quantity,0);
    cartSnapshot.total_price=cartSnapshot.items.reduce((n,i)=>n+i.final_line_price,0);
    render(JSON.parse(JSON.stringify(cartSnapshot)));
    updateQueue=updateQueue
      .then(()=>fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity})}))
      .then(r=>{if(!r.ok)throw new Error('Cart update failed');return r.json()})
      .then(cart=>{if(version===updateVersion)render(cart)})
      .catch(err=>{
        console.warn('SNOB cart update:',err);
        if(version!==updateVersion)return;
        return fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
          .then(r=>{if(!r.ok)throw new Error('Cart recovery failed');return r.json()})
          .then(cart=>{if(version===updateVersion)render(cart)});
      });
  }

  /* ---- gift note -------------------------------------------------------- */
  function saveGiftNote(btn){
    const note=$('#snobGiftNote'),status=$('#snobGiftStatus');if(!note)return;
    btn.disabled=true;if(status)status.textContent='Saving\u2026';
    fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({note:note.value.trim()})})
      .then(r=>{if(!r.ok)throw new Error('Could not save note');return r.json()})
      .then(cart=>{note.dataset.edited='1';if(status)status.textContent='Note saved';render(cart)})
      .catch(()=>{if(status)status.textContent='Could not save. Try again.'})
      .finally(()=>{btn.disabled=false});
  }

  function applyCoupon(){
    const input=$('#snobCouponCode'),code=input&&input.value.trim();
    if(code)window.location.assign(root+'discount/'+encodeURIComponent(code)+'?redirect=%2Fcheckout');
    else if(input)input.focus();
  }

  /* ---- events ----------------------------------------------------------- */
  document.addEventListener('click',e=>{
    const t=e.target;
    if(t.closest('#snobCartButton')){e.preventDefault();open();return}
    if(t.closest('#snobCartClose')||t.closest('#snobCartOverlay')){close();return}
    const q=t.closest('#snobCartDrawer [data-key][data-qty]');
    if(q){e.preventDefault();changeQuantity(q.dataset.key,Math.max(0,Number(q.dataset.qty)));return}
    const gift=t.closest('#snobGiftToggle');
    if(gift){
      const panel=$('#snobGiftPanel');if(!panel)return;
      panel.hidden=!panel.hidden;gift.setAttribute('aria-expanded',String(!panel.hidden));
      if(!panel.hidden){const n=$('#snobGiftNote');n&&n.focus({preventScroll:true})}
      return;
    }
    const save=t.closest('#snobGiftSave');if(save){saveGiftNote(save);return}
    if(t.closest('#snobCouponApply')){applyCoupon();return}
    const totalToggle=t.closest('#snobTotalToggle');
    if(totalToggle){const n=$('#snobTotalNote');if(n){n.hidden=!n.hidden;totalToggle.setAttribute('aria-expanded',String(!n.hidden))}return}
    if(t.closest('#snobDrawerCheckout'))window.location.assign(root+'checkout');
  });

  document.addEventListener('keydown',e=>{
    const d=$('#snobCartDrawer');if(!d||!d.classList.contains('show'))return;
    if(e.key==='Escape'){close();return}
    if(e.key==='Enter'&&e.target&&e.target.id==='snobCouponCode'){e.preventDefault();applyCoupon();return}
    if(e.key==='Tab'){ /* keep focus inside the open drawer */
      const f=[...d.querySelectorAll('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])')].filter(el=>el.offsetParent!==null);
      if(!f.length)return;
      const first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    }
  });

  document.addEventListener('snob:cart-updated',()=>refresh().catch(()=>{}));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>refresh().catch(()=>{}),{once:true});
  else refresh().catch(()=>{});
})();
